import { AxiosInstance } from 'axios';
import { CompanyHoliday, HolidayPayReview } from '../../types';

export function createHolidayApi(client: AxiosInstance) {
  return {
    async getHolidays(year?: number) {
      const url = year ? `/holidays?year=${year}` : '/holidays';
      const r = await client.get(url);
      return r.data as CompanyHoliday[];
    },
    async createHoliday(holiday_date: string, name?: string, paid_hours = 8, eligibility_mode: CompanyHoliday['eligibility_mode'] = 'review') {
      const r = await client.post('/holidays', { holiday_date, name: name || null, paid_hours, eligibility_mode });
      return r.data as CompanyHoliday;
    },
    async deleteHoliday(id: number) {
      const r = await client.delete(`/holidays/${id}`);
      return r.data as { ok: boolean };
    },
    async getHolidayPayReview(id: number) {
      const r = await client.get(`/holidays/${id}/review`);
      return r.data as HolidayPayReview;
    },
    async saveHolidayPayReview(id: number, entries: Array<{ employee_id: number; decision: string; paid_hours: number; reason?: string }>) {
      const r = await client.put(`/holidays/${id}/review`, { entries });
      return r.data as HolidayPayReview;
    },
    async finalizeHolidayPayReview(id: number) {
      const r = await client.post(`/holidays/${id}/review/finalize`);
      return r.data as { ok: true };
    },
    async reopenHolidayPayReview(id: number) {
      const r = await client.post(`/holidays/${id}/review/reopen`);
      return r.data as { ok: true };
    },
  };
}

export type HolidayApi = ReturnType<typeof createHolidayApi>;
